/*eslint-disable */
import root from '../_helpers/roots';
import axios from 'axios';
let UpdateProfileUrl = root.updateProfileUrl.link
let UpdateProfileAvatarUrl = root.updateProfileAvatarUrl.link
let mobileNoURL = root.mobileNoUrl.link
let mobileNoVerifyURL = root.mobileNoVerifyUrl.link
let aboutOfUserPrflApiURL = root.aboutOfUserPrflApiUrl.link
let aboutOfMemberUserPrflApiURL = root.aboutOfMemberUserPrflApiUrl.link
let emailUpdateOfProfileUrl = root.emailUpdateOfProfileUrl.link
let emailVerifiedOfProfileUrl = root.emailVerifiedOfProfileUrl.link

import Vue from 'vue'
export default {
  state: {
    updateProfileState:{},
    getAboutDetailsOfProfileState:{},
    getAboutDetailsOfMemberUserState:{}
  },
  mutations: {
    updateProfileMut(state, value) {
      Vue.set(state, 'updateProfileState', value);
    },
    getAboutDetailsOfProfileMut(state, value) {
      Vue.set(state, 'getAboutDetailsOfProfileState', value);
    },
    getAboutDetailsOfMemberUserMut(state, value) {
      Vue.set(state, 'getAboutDetailsOfMemberUserState', value);
    },
  },
  actions: {
    // Send Otp In Email Function
    optToEmailFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(emailUpdateOfProfileUrl, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Verify Otp In Email Function
    verifiedEmailOfProfileFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(emailVerifiedOfProfileUrl, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Profile About Function
    getAboutDetailsOfMemberUserFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(aboutOfMemberUserPrflApiURL + payload.id + '/', payload).then(res => {
              context.commit('getAboutDetailsOfMemberUserMut', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Profile About Function
    getAboutDetailsOfProfileFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(aboutOfUserPrflApiURL, payload).then(res => {
              context.commit('getAboutDetailsOfProfileMut', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Update Profile About Function
    updateAboutOfProfileFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(aboutOfUserPrflApiURL, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Update Profile Function
    updateProfileFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(UpdateProfileUrl, payload).then(res => {
              context.commit('updateProfileMut', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Update Profile Avatar Function
    updateProfileAvatarFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(UpdateProfileAvatarUrl, payload, {
              // headers: {
              //   'Content-Type': null
              // }
            }).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Update Profile Avatar Function
    removeProfileAvatarFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.delete(UpdateProfileAvatarUrl, payload, {
              // headers: {
              //   'Content-Type': null
              // }
            }).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Mobile No Create Function
    mobileNoCreatedFun(context, payload) {
      return new Promise((resolve, reject) => {
          axios.post(mobileNoURL, payload).then(res => {
            resolve(res);
          }).catch(err => {
            reject(err);
          })
      })
    },
    // Mobile No Verify Create Function
    mobileNoVerifiedFun(context, payload) {
      return new Promise((resolve, reject) => {
          axios.post(mobileNoVerifyURL, payload).then(res => {
            resolve(res);
          }).catch(err => {
            reject(err);
          })
      })
    }
  },
  getters: {
    updateProfileGetters: state => state.updateProfileState,
    getAboutDetailsOfProfileGetters: state => state.getAboutDetailsOfProfileState,
    getAboutDetailsOfMemberUserGetters: state => state.getAboutDetailsOfMemberUserState
  }
}